
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Meta, Title } from '@angular/platform-browser'
import { Router, RouterModule } from '@angular/router'
import { SITE_TITLE } from '../../../shared/constants'

@Component({
  selector: 'app-discount-calculator',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule
],
  templateUrl: './discount-calculator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './discount-calculator.component.scss'
})
export class DiscountCalculatorComponent {
  constructor(
    private meta: Meta,
    private title: Title,
    public http: HttpClient,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.discountForm = this.fb.group({
      originalPrice: ['', [Validators.required, Validators.min(0.01)]],
      discountPercentage: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
    })
  }

  public discountForm: FormGroup

  discountResultStr: string | null = null
  discountResult: number | null = null

  ngOnInit() {
    this.title.setTitle(SITE_TITLE + " | Discount Calculator")
    this.meta.updateTag({ name: 'description', content: 'Calculate the discounted price with our free online Discount Calculator.' })
    this.meta.updateTag({ name: 'keywords', content: 'discount, calculator, price, calculate, tool, free' })
  }

  onSubmit() {
    this.calculateDiscount()
  }

  calculateDiscount() {
    if (this.discountForm.valid) {
      const originalPrice = this.discountForm.value.originalPrice
      const discountPercentage = this.discountForm.value.discountPercentage
      this.discountResult = originalPrice - (originalPrice * (discountPercentage / 100))
      this.discountResultStr = this.discountResult.toFixed(2)
    }

    if (this.discountResult !== null) {
      // Display the result
      const resultElement = document.getElementById('discountResult')
      if (resultElement) {
        resultElement.innerText = `Discounted Price: $${this.discountResult.toFixed(2)}`
      }
    }
  }
}
